import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 h-full flex flex-col" }
const _hoisted_2 = { class: "trezo-card-content relative flex-1" }
const _hoisted_3 = { class: "flex items-center gap-3 mb-3" }
const _hoisted_4 = { class: "block text-sm font-semibold text-slate-600 dark:text-slate-300 tracking-wide uppercase" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_7 = {
  key: 1,
  class: "text-2xl sm:text-3xl font-bold text-slate-800 dark:text-slate-100"
}
const _hoisted_8 = { class: "absolute -top-[28px] ltr:-right-[9px] rtl:-left-[9px] max-w-[120px]" }
const _hoisted_9 = {
  key: 1,
  class: "h-[95px] flex items-center justify-center"
}
const _hoisted_10 = { class: "mt-[25px] md:mt-[34px] flex items-center justify-between" }
const _hoisted_11 = {
  key: 0,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = {
  key: 1,
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_13 = {
  key: 1,
  class: "inline-flex items-center gap-1 text-sm font-semibold py-2 px-3 rounded-xl text-orange-700 dark:text-orange-300 bg-orange-100 dark:bg-orange-900/30 border border-orange-200 dark:border-orange-800 transition-all duration-300 shadow-sm"
}
const _hoisted_14 = { class: "block text-sm font-medium text-slate-500 dark:text-slate-400 tracking-wide" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-gradient-to-br from-purple-400 to-purple-600 dark:from-purple-500 dark:to-indigo-600 flex items-center justify-center shadow-lg" }, [
          _createElementVNode("svg", {
            class: "w-5 h-5 text-white",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
            })
          ])
        ], -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.directT('dashboard.crm.annualProfit')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "h-8 bg-slate-200 dark:bg-slate-700 rounded-lg animate-pulse w-32" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.currencySymbol) + _toDisplayString(_ctx.totalProfit.toLocaleString()), 1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.isClient && _ctx.monthlyProfits && _ctx.monthlyProfits.length > 0)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "95",
              options: _ctx.annualProfit,
              series: _ctx.profit
            }, null, 8, ["options", "series"]))
          : (_ctx.isClient && _ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "w-20 h-12 bg-slate-200 dark:bg-slate-700 rounded animate-pulse" }, null, -1)
              ])))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.growthPercentage !== null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["inline-flex items-center gap-1 text-sm font-semibold py-2 px-3 rounded-xl transition-all duration-300 shadow-sm", _ctx.growthPercentage >= 0 ? 'text-success-700 border-success-300 bg-success-100' : 'text-danger-700 border-danger-300 bg-danger-100'])
            }, [
              (_ctx.growthPercentage >= 0)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[3] || (_cache[3] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M7 11l5-5m0 0l5 5m-5-5v12"
                    }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("svg", _hoisted_12, _cache[4] || (_cache[4] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M17 13l-5 5m0 0l-5-5m5 5V6"
                    }, null, -1)
                  ]))),
              _createTextVNode(" " + _toDisplayString(_ctx.growthPercentage >= 0 ? '+' : '') + _toDisplayString(_ctx.growthPercentage) + "% ", 1)
            ], 2))
          : (_openBlock(), _createElementBlock("span", _hoisted_13, [
              _cache[5] || (_cache[5] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.directT('dashboard.annual')), 1)
            ])),
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.directT('dashboard.last12Months')), 1)
      ])
    ])
  ]))
}